module.exports = __webpack_public_path__ + "assets/img/nx-05.41f848b9.jpg";